import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Spinner } from '../../elements';

const DismissalTermStep = ({
  loadingDismissalTerm,
  submitting,
  dismissalTerm,
  backClick,
  onSubmit,
}) => (
  <Spinner action={loadingDismissalTerm}>
    <div className="dismissal-term">
      <h2 className="dismissal-term-title">DECLARAÇÃO</h2>
      {
        get(dismissalTerm, 'dismissal_onboardings.length', []) === 0 ? (
          <p>Eu, <strong>{dismissalTerm.real_name}</strong>, CPF nº <strong>{dismissalTerm.cpf}</strong>, aprovado(a) no processo seletivo <strong>{dismissalTerm.course}</strong> para o curso de <strong>{get(dismissalTerm, 'onboarding.specialty')}</strong> na Instituição <strong>{get(dismissalTerm, 'onboarding.hospital')}</strong>, conforme resultado final, DECLARO ter interesse em ser matriculado(a) neste curso.</p>
        ) : (
          <>
            <p className="dismissal-term-paragraph">
              Eu, <strong>{dismissalTerm.real_name}</strong>, CPF nº <strong>{dismissalTerm.cpf}</strong>, aprovado(a) no processo seletivo <strong>{dismissalTerm.course}</strong> para o(s) curso(s) de:
            </p>
            <ul className="dismissal-term-list">
              {get(dismissalTerm, 'dismissal_onboardings', []).map(dismissal_onboarding => (
                <li>
                  <strong>{dismissal_onboarding.specialty}</strong>, na Instituição <strong>{dismissal_onboarding.hospital}</strong>
                </li>
              ))}
            </ul>
            <p className="dismissal-term-paragraph">
              Conforme resultado final, DECLARO não ter interesse em ser matriculado para o(s) curso(s) acima, desistindo da vaga no referido processo seletivo, tendo em vista que também fui aprovado e desejo ser matriculado no curso de <strong>{get(dismissalTerm, 'onboarding.specialty')}</strong> na Instituição <strong>{get(dismissalTerm, 'onboarding.hospital')}</strong>.
            </p>
          </>
        )
      }
    </div>
    <div className="text-right mt-3">
      <div className="col-md-4 p-0 offset-md-8 col-sm-12">
        <div className="btn-actions">
          <button
            className="btn btn-black mr-2"
            type="submit"
            onClick={() => backClick()}
          >
            Voltar
          </button>
          <button
            disabled={submitting}
            className="btn btn-primary"
            type="submit"
            onClick={() => onSubmit()}
          >
            {submitting ? 'Carregando...' : 'ACEITAR TERMO'}
          </button>
        </div>
      </div>
    </div>
  </Spinner>
);

DismissalTermStep.propTypes = {
  loadingDismissalTerm: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dismissalTerm: PropTypes.string.isRequired,
  backClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default DismissalTermStep;
